import type { ReportDateRangeOption } from '@/hooks/useReportDateRange';

const DATE_RANGE_KEYS: Record<ReportDateRangeOption, string> = {
  Today: 'dates.today',
  Yesterday: 'dates.yesterday',
  'This Week': 'dates.thisWeek',
  'Last Week': 'dates.lastWeek',
  'This Month': 'dates.thisMonth',
  'Last Month': 'dates.lastMonth',
  'This Quarter': 'dates.thisQuarter',
  'This Year': 'dates.thisYear',
  'Custom Date': 'dates.custom',
};

export function dateRangeLabelKey(opt: ReportDateRangeOption | string): string {
  return DATE_RANGE_KEYS[opt as ReportDateRangeOption] || opt;
}
